import { Formik, FormikConfig } from 'formik';
import { useTranslation } from 'react-i18next';
import { FormField, Input } from '@redislabsdev/redis-ui-components';
import { useLocation } from 'react-router-dom';
import * as S from './SetNewPasswordForm.style';
import { i18translation } from '../../../../locale/translations/i18NsPaths';
import { buildValidationSchema } from '../../utils/resetPassword';
import { ResetPasswordFormValues } from '../ResetPassword/ResetPassword.types';

const SetNewPasswordForm = ({
  handleSubmit
}: {
  handleSubmit: FormikConfig<ResetPasswordFormValues>['onSubmit'];
}) => {
  const { t } = useTranslation();
  const keyPrefix = i18translation.LoginScreen.resetPasswordScreen;
  const { search } = useLocation();
  const searchParams = new URLSearchParams(search);
  const isInvitation = searchParams.has('invitation');

  return (
    <S.SetNewPasswordFormContainer>
      <Formik
        onSubmit={handleSubmit}
        initialValues={{
          password: '',
          confirm_password: ''
        }}
        validationSchema={() => buildValidationSchema(t)}
        validateOnMount
      >
        {({ dirty, isSubmitting, isValid, handleChange, errors, touched, handleBlur }) => (
          <S.SetNewPasswordForm>
            <FormField label={t(keyPrefix.newPassword)}>
              <Input
                data-testid="textinput--password"
                type="password"
                name="password"
                error={touched.password && errors.password}
                onChange={handleChange('password')}
                onBlur={handleBlur}
              />
            </FormField>
            <FormField label={t(keyPrefix.reEnterPassword)}>
              <Input
                data-testid="textinput--repeated-password"
                type="password"
                name="confirm_password"
                error={touched.confirm_password && errors.confirm_password}
                onBlur={handleBlur}
                onChange={handleChange('confirm_password')}
              />
            </FormField>
            <S.SubmitButton
              data-testid="button--submit"
              disabled={!dirty || !isValid || isSubmitting}
              type="submit"
            >
              {t(isInvitation ? keyPrefix.updatePasswordBtn : keyPrefix.resetPasswordBtn)}
            </S.SubmitButton>
          </S.SetNewPasswordForm>
        )}
      </Formik>
    </S.SetNewPasswordFormContainer>
  );
};

export default SetNewPasswordForm;
